'use client';

export const ES = {
  test: {
    'This is a test 1': 'Esta es una prueba string 1',
    'This is a test 2': 'Esto es una prueba string 2',

    Item_one: 'Artículo',
    Item_other: 'Artículo',

    Apple_one: '{{count}} manzana',
    Apple_other: '{{count}} manzanas',
  },

  'Go back home': 'Regresar al inicio',

  "We can't find the page you're looking for.":
    'No podemos encontrar la página que está buscando.',
};
